/* eslint-disable */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  Form,
} from 'reactstrap';
import { IconContext } from 'react-icons';
import { ImArrowLeft2 } from 'react-icons/im';
import { withRouter, RouteComponentProps } from 'react-router-dom';

// ========= action import section ========= //
import {
  getUserVoucher,
  getUserRaffle,
  getVoucherHistory,
  getRaffleHistory,
} from '../../actions/kickPointAction';
// ====== end of action import section ====== //

// ========= action import COMPONENTS ========= //

// ====== end of action import COMPONENTS ====== //

import BodyVoucher from './MyVouchersTabs/BodyVoucher';
import UserRaffle from './MyVouchersTabs/UserRaffle';
import UserVoucher from './MyVouchersTabs/UserVoucher';
import Paginations from './MyVouchersTabs/Pagination';
import AuthInterface from '../../interface/reducers/auth';

// ========= interface import section ========= //

interface withRouterProps extends RouteComponentProps<any> {
  title: string;
}

interface getUserVoucherPayload {
  page: number;
}
interface getUserRafflePayload {
  page: number;
}
interface getUserVoucherHistoryPayload {
  page?: number;
  status?: string;
  keyword?: string;
}
interface getRaffleHistoryPayload {
  page?: number;
  status?: string;
  keyword?: string;
}

interface obj {
  length: any;
}

interface userVoucher {
  data: obj | Array<obj> | obj;
  [index: string]: any;
}
interface userRaffle {
  data: obj | Array<obj> | obj;
  [index: string]: any;
}
interface voucherHistory {
  data: obj | Array<obj> | obj;
  [index: string]: any;
}
interface raffleHistory {
  data: obj | Array<obj> | obj;
  [index: string]: any;
}
interface dataKickPoint {
  userVoucher: userVoucher;
  userRaffle: userRaffle;
  voucherHistory: voucherHistory;
  raffleHistory: raffleHistory;
}

// ====== end of interface import section ====== //

type myRewards = {
  history: any;
  routes: any;
  dataVoucher: userVoucher;
  dataRaffle: userRaffle;
  voucherHistory: voucherHistory;
  raffleHistory: raffleHistory;
  getUserVoucher: (payload: getUserVoucherPayload) => any;
  getUserRaffle: (payload: getUserRafflePayload) => any;
  getVoucherHistory: (payload: getUserVoucherHistoryPayload) => any;
  getRaffleHistory: (payload: getRaffleHistoryPayload) => any;
  dataAuth: AuthInterface;
};

type stateToProps = {
  dataKickPoint: dataKickPoint;
  dataAuth: AuthInterface;
};

/**
 * My Rewards User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {myRewards} props for this component.
 * @return {JSX.Element}
 */
function MyRewards({
  dataVoucher,
  dataRaffle,
  voucherHistory,
  raffleHistory,
  getUserVoucher,
  getUserRaffle,
  getVoucherHistory,
  getRaffleHistory,
  history,
  routes,
  dataAuth,
}: myRewards): JSX.Element {
  const [activeTab, setActiveTab] = useState(1);
  const [voucherKeyword, setVoucherKeyword] = useState('');
  const [raffleKeyword, setRaffleKeyword] = useState('');
  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    getUserVoucher({ page: 1 });
    getUserRaffle({ page: 1 });
  }, []);

  /* ========METHODS======== */
  const toggle = (tabs: number) => {
    setActiveTab(tabs);
    setVoucherKeyword('');
    setRaffleKeyword('');

    switch (tabs) {
      case 1:
        return getUserVoucher({ page: 1 });
      case 2:
        return getUserRaffle({ page: 1 });
      case 3:
        return getVoucherHistory({ page: 1 });
      case 4:
        return getRaffleHistory({ page: 1 });
      default:
        return null;
    }
  };

  const paginationEachTab = (tab: number) => {
    switch (tab) {
      case 1:
        return dataVoucher.data.length !== 0;
      case 2:
        return dataRaffle.data.length !== 0;
      case 3:
        return voucherHistory.data.length !== 0;
      case 4:
        return raffleHistory.data.length !== 0;

      default:
        return false;
    }
  };

  const checkPageTab = (tab: number, keys: string) => {
    switch (tab) {
      case 1:
        return dataVoucher[keys];
      case 2:
        return dataRaffle[keys];
      case 3:
        return voucherHistory[keys];
      case 4:
        return raffleHistory[keys];
      default:
        return 0;
    }
  };

  const handleToGo = (e: any, page: number) => {
    e.preventDefault();
    switch (activeTab) {
      case 1:
        return getUserVoucher({ page });
      case 2:
        return getUserRaffle({ page });
      case 3:
        return getVoucherHistory({
          page,
          status: 'history',
          keyword: voucherKeyword,
        });
      case 4:
        return getRaffleHistory({
          page,
          status: 'history',
          keyword: raffleKeyword,
        });

      default:
        return null;
    }
  };

  const onSearchHandle = (e: any) => {
    e.preventDefault();

    switch (activeTab) {
      case 3:
        return getVoucherHistory({
          status: 'history',
          keyword: voucherKeyword,
        });
      case 4:
        return getRaffleHistory({ status: 'history', keyword: raffleKeyword });

      default:
        return null;
    }
  };

  const onRefreshData = (e: any, page: number) => {
    switch (activeTab) {
      case 1:
        return getUserVoucher({ page: 1 });
      case 2:
        return getUserRaffle({ page: 1 });
      case 3:
        return getVoucherHistory({ page: 1, status: 'history' });
      case 4:
        return getRaffleHistory({ page: 1, status: 'history' });

      default:
        return null;
    }
  };

  const renderTabContent = () => {
    return (
      <div className="render-tab-content">
        <TabContent activeTab={activeTab}>
          <TabPane tabId={1}>
            <UserVoucher
              dataList={dataVoucher}
              onClick={(args: boolean) => setIsOpenModal(args)}
              onRefresh={onRefreshData}
              currency={dataAuth.userCurrency.currency}
              ratio={dataAuth.userCurrency.ratio}
            />
          </TabPane>
          <TabPane tabId={2}>
            <UserRaffle
              dataList={dataRaffle}
              onClick={(args: boolean) => setIsOpenModal(args)}
              onRefresh={onRefreshData}
            />
          </TabPane>
          <TabPane tabId={3}>
            <BodyVoucher dataList={voucherHistory} onRefresh={onRefreshData} />
          </TabPane>
        </TabContent>
      </div>
    );
  };

  /* ====END OF METHODS==== */
  return (
    <div className="new-rewards-container">
      <div className="rewards-header">
        <div className="header-title">
          <div
            className="back-button"
            onClick={() => history.push({ pathname: `/user_dashboard` })}
          >
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div>
                <ImArrowLeft2 />
              </div>
            </IconContext.Provider>
          </div>
          <p>My Vouchers</p>
        </div>
        <div className="header-nav-n-pagination">
          <Nav tabs className="new-voucher-nav">
            <NavItem>
              <NavLink
                onClick={() => {
                  toggle(1);
                }}
                className={`${activeTab === 1 ? 'active' : ''}`}
              >
                <p>Active</p>
                {activeTab === 1 && <div className="active-tab-underline" />}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                onClick={() => {
                  toggle(3);
                }}
                className={`${activeTab === 3 ? 'active' : ''}`}
              >
                <p>History</p>
                {activeTab === 3 && <div className="active-tab-underline" />}
              </NavLink>
            </NavItem>
          </Nav>
          {paginationEachTab(activeTab) ? (
            <Paginations
              currentPage={checkPageTab(activeTab, 'current_page')}
              lastPage={checkPageTab(activeTab, 'last_page')}
              perPage={checkPageTab(activeTab, 'per_page')}
              total={checkPageTab(activeTab, 'total')}
              prevPageUrl
              handleGoto={handleToGo}
              nextPageUrl
              maxPage={5}
            />
          ) : null}
        </div>
      </div>
      {renderTabContent()}
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataVoucher: state.dataKickPoint.userVoucher,
    dataRaffle: state.dataKickPoint.userRaffle,
    voucherHistory: state.dataKickPoint.voucherHistory,
    raffleHistory: state.dataKickPoint.raffleHistory,
    dataAuth: state.dataAuth,
  };
};

const mapDispatchToProps = (dispatch: (arg: any) => any) => {
  return {
    getUserVoucher: (payload: getUserVoucherPayload) =>
      dispatch(getUserVoucher(payload)),
    getUserRaffle: (payload: getUserRafflePayload) =>
      dispatch(getUserRaffle(payload)),
    getVoucherHistory: (payload: getUserVoucherHistoryPayload) =>
      dispatch(getVoucherHistory(payload)),
    getRaffleHistory: (payload: getRaffleHistoryPayload) =>
      dispatch(getRaffleHistory(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter<any, any>(MyRewards));
